// React
import React, { useState, useEffect, useRef } from 'react';

// Components
import Wrapper from '../../detail/Wrapper/Wrapper';

// Contexts
import { DetailContext } from '../../../contexts/detail';

// Hooks
import useDetail from '../../../hooks/useDetail';
import useMounted from '../../../hooks/useMounted';

// Third party
import { useParams } from 'react-router-dom';

// Data types
import {
  upholsteryCore,
  upholsteryDetail
} from '../../../data-types/upholstery';
import eventBus from '../../../shared/eventBus';

// This component
export default function UpholsteryDetail() {
  const { itemId } = useParams();
  const isNewItem = itemId === 'new';

  // Data types
  const { endpointByTrim, getDetailId } = upholsteryCore();
  const {
    baseUrl,
    getInputs,
    watchedParameters,
    generateUpholsteryCode
   } = upholsteryDetail();

  // Detail
  const { cultures, saveCulturesDataSource, saveCultures } = useDetail();

  const mounted = useMounted();

  const generateUpholsteryCodeRef = useRef(generateUpholsteryCode);
  const watchedParametersRef = useRef(watchedParameters);

  const [generatedValues, setGeneratedValues] = useState({
    generateUpholsteryCode: null
  });

  useEffect(()=>{

    for (let key in watchedParametersRef.current) {

      eventBus.on(`formInputChange_${key}`, (data_) => {

        if(
          mounted.current &&
          watchedParametersRef.current.hasOwnProperty(data_.parameter)
        ) {

          watchedParametersRef.current[key] = data_;

          const generateUpholsteryCode = generateUpholsteryCodeRef.current(
            watchedParametersRef.current['yearId'],
            watchedParametersRef.current['trimId']
          );

          setGeneratedValues({
            generateUpholsteryCode: generateUpholsteryCode
          });

        }

      });

    }

  },[mounted]);

  // JSX
  return (
    <DetailContext.Provider
      value={{
        typeOfData: 'data-type',
        title: 'Upholstery',
        // Static
        itemId,
        isNewItem,
        endpoint: endpointByTrim,
        baseUrl,
        getDetailId,
        getInputs,
        generatedValues,
        // Dynamic
        cultures,
        saveCulturesDataSource,
        saveCultures
      }}>
      <Wrapper />
    </DetailContext.Provider>
  );
}
